import React, { Fragment, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateTimesheetPeriodTypesAsync, resetSelectedRecordObjectInState } from "./TimesheetPeriodTypeSlice";
import { TimesheetPeriodTypeInitialsForAdd, TimesheetPeriodTypeInitialsForUpdate } from "./interfaces/TimesheetPeriodTypeClass";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { KTSVG } from "../../../_metronic/helpers";
import { dateFormatByAccountCulture, dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';

export const TimesheetPeriodTypeForm = (props: any) => {
    const { modelRef, t, oncloseModal } = props;
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector(state => state.globalState);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(TimesheetPeriodTypeInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.timesheetPeriodType);
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [systemTimesheetPeriodTypeArray, setSystemTimesheetPeriodTypeArray] = useState<any | ''>([]);
    const [selectedSystemTimesheetPeriodTypeValue, setSelectedSystemTimesheetPeriodTypeValue] = useState(-1);
    const [systemInitialDaysOfThePeriodArray, setSystemInitialDaysOfThePeriodArray] = useState<any | ''>([]);

    const getSystemTimesheetPeriodTypeAsync = async () => {
        const response = await fetchAPI("api/V2/TimesheetPeriodTypes/SystemTimesheetPeriodTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.SystemTimesheetPeriodTypeId;
            item.label = item.SystemTimesheetPeriodType;
            delete item.SystemTimesheetPeriodTypeId;
            delete item.SystemTimesheetPeriodType;
        });
        setSystemTimesheetPeriodTypeArray(json.Data);
    }

    const getSystemInitialDaysOfThePeriodAsync = async () => {
        const response = await fetchAPI("api/V2/TimesheetPeriodTypes/SystemInitialDaysOfThePeriod", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.SystemInitialDaysOfThePeriodId;
            item.label = item.SystemInitialDaysOfThePeriod;
            delete item.SystemInitialDaysOfThePeriodId;
            delete item.SystemInitialDaysOfThePeriod;
        });
        setSystemInitialDaysOfThePeriodArray(json.Data);
    }

    useEffect(() => {
        const fetchData = async () => {
            await getSystemTimesheetPeriodTypeAsync();
            await getSystemInitialDaysOfThePeriodAsync();
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (systemTimesheetPeriodTypeArray.length > 0 && Object.keys(selectedRecord).length > 0) {
            let stateItem: any = {};
            const tempObj: any = selectedRecord;
            Object.keys(TimesheetPeriodTypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            });
            setSelectedSystemTimesheetPeriodTypeValue(systemTimesheetPeriodTypeArray.find((systemTimesheetPeriodType: any) => systemTimesheetPeriodType.value == stateItem.SystemTimesheetPeriodTypeId).value);
            //  stateItem.TimesheetPeriodEffectiveDate = undefined;//new Date(stateItem.TimesheetPeriodEffectiveDate);
            // stateItem.TimesheetPeriodEffectiveDate = stateItem.TimesheetPeriodEffectiveDate === null ? undefined : new Date(stateItem.TimesheetPeriodEffectiveDate)
            stateItem.TimesheetPeriodEffectiveDate = stateItem.TimesheetPeriodEffectiveDate === null ? undefined : dateFormatByAccountCulture(moment.parseZone(new Date(stateItem.TimesheetPeriodEffectiveDate)).format('YYYY-MM-DD'), cultureInfoName.toString())
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        } else {
            setCurrentFieldsData(TimesheetPeriodTypeInitialsForAdd);
        }

        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }, [systemTimesheetPeriodTypeArray, selectedRecord]);

    // const handleSubmit = (values: any) => {
    //     if (Object.keys(selectedRecord).length > 0) {
    //         // values.TimesheetPeriodEffectiveDate = selectedSystemTimesheetPeriodTypeValue != 3 ? null : moment(values.TimesheetPeriodEffectiveDate).format('MM/DD/YYYY');
    //         //values.TimesheetPeriodEffectiveDate = selectedSystemTimesheetPeriodTypeValue != 3 ? null : moment(values.TimesheetPeriodEffectiveDate).format(dateInsertionFormat);
    //         values.InitialDayOfTheMonth = selectedSystemTimesheetPeriodTypeValue != 5 ? null : values.InitialDayOfTheMonth;
    //         dispatch(updateTimesheetPeriodTypesAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 originalPromiseResult.StatusCode === "200" ?
    //                     ShowToast("Timesheet Period Type Update Successfully", 'Success', "success", "toast-top-right") :
    //                     ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
    //             }).catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     oncloseModal();
    // }

    const handleSubmit = (values: any) => {
        const updatedValues = { ...values };
        if (updatedValues.selectedSystemTimesheetPeriodTypeValue !== 3) {
            updatedValues.TimesheetPeriodEffectiveDate = null;
        } else {
            updatedValues.TimesheetPeriodEffectiveDate = updatedValues.TimesheetPeriodEffectiveDate
                ? moment(updatedValues.TimesheetPeriodEffectiveDate).format(dateInsertionFormat)
                : null;
        }
        updatedValues.InitialDayOfTheMonth = updatedValues.selectedSystemTimesheetPeriodTypeValue !== 5 ? null : updatedValues.InitialDayOfTheMonth;
        dispatch(updateTimesheetPeriodTypesAsync(values))
            .unwrap()
            .then((originalPromiseResult) => {
                originalPromiseResult.StatusCode === "200" ?
                    ShowToast("Timesheet Period Type Update Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
            }).catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })
        oncloseModal();
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    const handleSystemTimesheetPeriodOptionChange = (data: any) => {
        const { value, label } = data;
        setSelectedSystemTimesheetPeriodTypeValue(systemTimesheetPeriodTypeArray.find((systemTimesheetPeriodType: any) => systemTimesheetPeriodType.value === value).value);
    };

    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    InitialDayOfTheMonth: currentFieldsData?.InitialDayOfTheMonth || 0,
                    TimesheetPeriodEffectiveDate: currentFieldsData?.TimesheetPeriodEffectiveDate || null,
                    selectedSystemTimesheetPeriodTypeValue
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    InitialDayOfTheMonth: yup
                        .number()
                        .nullable()
                        .when('selectedSystemTimesheetPeriodTypeValue', {
                            is: (val: Number) => val === 5,
                            then: (schema) =>
                                schema
                                    .required(
                                        getValueFromResource('Initial Day Of The Month is required', dispatch, t)
                                    )
                                    .min(
                                        1,
                                        getValueFromResource(
                                            'Initial Day Of The Month value must be greater than or equal to 1',
                                            dispatch,
                                            t
                                        )
                                    )
                                    .max(
                                        31,
                                        getValueFromResource(
                                            'Initial Day Of The Month value must be less than or equal to 31',
                                            dispatch,
                                            t
                                        )
                                    ),
                            otherwise: (schema) => schema,
                        }),
                })}
            // validationSchema={yup.object().shape({
            //     TimesheetPeriodEffectiveDate: yup.date().when('selectedSystemTimesheetPeriodTypeValue', ([selectedSystemTimesheetPeriodTypeValue], schema) => {
            //         if (selectedSystemTimesheetPeriodTypeValue == 3) {
            //             return yup.date().required
            //             // (t('Effective Date is required'));
            //         (getValueFromResource('Effective Date is required',dispatch, t));
            //         }
            //         return schema;
            //     }),
            //     InitialDayOfTheMonth: yup.string().when('selectedSystemTimesheetPeriodTypeValue', ([selectedSystemTimesheetPeriodTypeValue], schema) => {
            //         if (selectedSystemTimesheetPeriodTypeValue == 5) {
            //             return yup.number().required
            //             // (t('Initial Day Of The Month is required'))
            //             (getValueFromResource('Initial Day Of The Month is required',dispatch, t))
            //                 .min(1, 
            //                     // t('Initial Day Of The Month value must be greater than or equal to 1'))
            //                     getValueFromResource('Initial Day Of The Month value must be greater than or equal to 1',dispatch, t))
            //                 .max(31, 
            //                     // t('Initial Day Of The Month value must be less than or equal to 31'));
            //                     getValueFromResource('Initial Day Of The Month value must be less than or equal to 31',dispatch, t))
            //         }
            //         return schema;
            //     }),
            // })}
            >
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>

                        <div className='card-body'>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                        //  t('Update')
                                                        getValueFromResource('Update ', dispatch, t)
                                                        :
                                                        //   t('Add')}
                                                        getValueFromResource('Add ', dispatch, t)}
                                                        {/* //   {t('Timesheet Period Type')}  */}
                                                        {getValueFromResource('Timesheet Period Type', dispatch, t)}
                                                    </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="modal-body">

                                                    <div className="col-md-12 mb-2">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t('Timesheet Period Type')} */}
                                                            {getValueFromResource('Timesheet Period Type', dispatch, t)}
                                                        </label>
                                                        <Select
                                                            value={(values.SystemTimesheetPeriodTypeId != "" && values.SystemTimesheetPeriodTypeId != null) ? systemTimesheetPeriodTypeArray.find((option: any) => option.value == values.SystemTimesheetPeriodTypeId) : 0}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            id="SystemTimesheetPeriodTypeId"
                                                            name="SystemTimesheetPeriodTypeId"
                                                            onBlur={() => setFieldTouched('SystemTimesheetPeriodTypeId', true)}
                                                            onChange={(selectedOption) => {
                                                                handleChange({
                                                                    target: {
                                                                        id: "SystemTimesheetPeriodTypeId",
                                                                        value: selectedOption?.value
                                                                    },
                                                                });
                                                                handleSystemTimesheetPeriodOptionChange(selectedOption);
                                                            }}
                                                            options={systemTimesheetPeriodTypeArray}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                            isDisabled={true}
                                                        />

                                                    </div>
                                                    {selectedSystemTimesheetPeriodTypeValue == 3 ?
                                                        <div className="col-md-12 mb-2">
                                                            <label className="form-label fs-7 fw-normal mb-2">
                                                                {/* {t('Effective Date')} */}
                                                                {getValueFromResource('Effective Date', dispatch, t)}
                                                            </label>
                                                            <div className="wrapper">
                                                                <DatePicker
                                                                    selected={values.TimesheetPeriodEffectiveDate != "" ? values.TimesheetPeriodEffectiveDate : null}
                                                                    //selected={values.TimesheetPeriodEffectiveDate || null}
                                                                    id="TimesheetPeriodEffectiveDate"
                                                                    name="TimesheetPeriodEffectiveDate"
                                                                    calendarStartDay={calendarStartDay}
                                                                    className="form-control w-452px ps-4 fs-7 fw-normal"
                                                                    onChange={(date) => setFieldValue('TimesheetPeriodEffectiveDate', date)}
                                                                    onBlur={() => setFieldTouched('TimesheetPeriodEffectiveDate')}
                                                                    // dateFormat="dd/MM/yyyy"
                                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                                >
                                                                </DatePicker>
                                                                <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                            </div>

                                                            {/* <DateRangePicker
                                                                onChange={(date) => setFieldValue('TimesheetPeriodEffectiveDate', date)}
                                                                selected={values.TimesheetPeriodEffectiveDate != "" ? values.TimesheetPeriodEffectiveDate : new Date()}
                                                                placeholder='Please Select Date Range'
                                                                cleanable={false}
                                                                placement="bottomEnd"
                                                            ></DateRangePicker> */}

                                                            <div>
                                                                {touched.TimesheetPeriodEffectiveDate && errors.TimesheetPeriodEffectiveDate &&
                                                                    <p className='errorMsg'>{errors.TimesheetPeriodEffectiveDate as string}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        : (
                                                            null
                                                        )}
                                                    {selectedSystemTimesheetPeriodTypeValue == 4 ?
                                                        <div className="col-md-12 mb-2">
                                                            <label className="form-label">
                                                                {/* {t('Period')} */}
                                                                {getValueFromResource('Period', dispatch, t)}
                                                            </label>
                                                            <Select
                                                                value={(values.SystemInitialDaysOfThePeriodId != null && values.SystemInitialDaysOfThePeriodId != "") ? systemInitialDaysOfThePeriodArray.find((option: any) => option.value == values.SystemInitialDaysOfThePeriodId) : 0}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                isSearchable={true}
                                                                id="SystemInitialDaysOfThePeriodId"
                                                                name="SystemInitialDaysOfThePeriodId"
                                                                onBlur={() => setFieldTouched('SystemInitialDaysOfThePeriodId', true)}
                                                                onChange={(selectedOption) => {
                                                                    handleChange({
                                                                        target: {
                                                                            id: "SystemInitialDaysOfThePeriodId",
                                                                            value: selectedOption?.value
                                                                        },
                                                                    });

                                                                }}
                                                                options={systemInitialDaysOfThePeriodArray}
                                                            />
                                                            <div>
                                                                {touched.SystemInitialDaysOfThePeriodId && errors.SystemInitialDaysOfThePeriodId &&
                                                                    <p className='errorMsg'>{errors.SystemInitialDaysOfThePeriodId as string}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        : (
                                                            null
                                                        )}
                                                    {selectedSystemTimesheetPeriodTypeValue == 5 ?
                                                        <div className="col-md-12 mb-2">
                                                            <label className="form-label">
                                                                {/* {t('Initial Day Of Month')} */}
                                                                {getValueFromResource('Initial Day Of Month', dispatch, t)}
                                                            </label>
                                                            <input type="number"
                                                                className="form-control fs-7 fw-normal"
                                                                name="InitialDayOfTheMonth"
                                                                id='InitialDayOfTheMonth'
                                                                value={(values.InitialDayOfTheMonth !== null && values.InitialDayOfTheMonth != "") ? values.InitialDayOfTheMonth : 0}
                                                                onChange={handleChange('InitialDayOfTheMonth')}
                                                                onBlur={() => setFieldTouched('InitialDayOfTheMonth')}
                                                            />
                                                            <div>
                                                                {touched.InitialDayOfTheMonth && errors.InitialDayOfTheMonth &&
                                                                    <p className='errorMsg'>{errors.InitialDayOfTheMonth as string}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        : (
                                                            null
                                                        )}
                                                </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel', dispatch, t)}
                                                    </button>
                                                    <button type="button"
                                                        className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                                        onClick={() => handleSubmit()}
                                                    //disabled={!isValid}
                                                    >
                                                        {/* {t('Save')}   */}
                                                        {getValueFromResource('Save', dispatch, t)}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>

                    </Fragment>
                )}
            </Formik>
        </>
    )

    // const [currentFieldsData, setCurrentFieldsData] = useState<any>(TimesheetPeriodTypeInitialsForAdd);
    // const { selectedRecord, isLoading } = useAppSelector((state) => state.timesheetPeriodType);
    // const dispatch = useAppDispatch();
    // const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    // const [systemTimesheetPeriodTypeArray, setSystemTimesheetPeriodTypeArray] = useState<any | ''>([]);
    // const [selectedSystemTimesheetPeriodTypeValue, setSelectedSystemTimesheetPeriodTypeValue] = useState(-1);
    // const [systemInitialDaysOfThePeriodArray, setSystemInitialDaysOfThePeriodArray] = useState<any | ''>([]);

    // const getSystemTimesheetPeriodTypeAsync = async () => {
    //     const response = await fetchAPI("api/V2/TimesheetPeriodTypes/SystemTimesheetPeriodTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    //     const json = await response.json();
    //     json.Data.map((item: any) => {
    //         item.value = item.SystemTimesheetPeriodTypeId;
    //         item.label = item.SystemTimesheetPeriodType;
    //         delete item.SystemTimesheetPeriodTypeId;
    //         delete item.SystemTimesheetPeriodType;
    //     });
    //     setSystemTimesheetPeriodTypeArray(json.Data);
    // }
    // const getSystemInitialDaysOfThePeriodAsync = async () => {
    //     const response = await fetchAPI("api/V2/TimesheetPeriodTypes/SystemInitialDaysOfThePeriod", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    //     const json = await response.json();
    //     json.Data.map((item: any) => {
    //         item.value = item.SystemInitialDaysOfThePeriodId;
    //         item.label = item.SystemInitialDaysOfThePeriod;
    //         delete item.SystemInitialDaysOfThePeriodId;
    //         delete item.SystemInitialDaysOfThePeriod;
    //     });
    //     setSystemInitialDaysOfThePeriodArray(json.Data);
    // }

    // useEffect(() => {
    //     getSystemTimesheetPeriodTypeAsync();
    //     getSystemInitialDaysOfThePeriodAsync();
    // }, [])

    // useEffect(() => {
    //     let stateItem: any = {}
    //     if (Object.keys(selectedRecord).length > 0) {
    //         const tempObj: any = selectedRecord;
    //         Object.keys(TimesheetPeriodTypeInitialsForUpdate).map((item) => {
    //             return stateItem[item] = tempObj[item];
    //         })

    //         setSelectedSystemTimesheetPeriodTypeValue(systemTimesheetPeriodTypeArray.find((systemTimesheetPeriodType: any) => systemTimesheetPeriodType.value == stateItem.SystemTimesheetPeriodTypeId).value);
    //         stateItem.TimesheetPeriodEffectiveDate = new Date(stateItem.TimesheetPeriodEffectiveDate);
    //         stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
    //         setCurrentFieldsData(stateItem);
    //     }
    //     else {
    //         setCurrentFieldsData(TimesheetPeriodTypeInitialsForAdd);
    //     }
    // }, [selectedRecord])

    // const handleSubmit = (values: any) => {
    //     if (Object.keys(selectedRecord).length > 0) {
    //         values.TimesheetPeriodEffectiveDate = selectedSystemTimesheetPeriodTypeValue != 3 ? null : moment(values.TimesheetPeriodEffectiveDate).format('MM/DD/YYYY') ;
    //         values.InitialDayOfTheMonth = selectedSystemTimesheetPeriodTypeValue != 5 ? null : values.InitialDayOfTheMonth;

    //         dispatch(updateTimesheetPeriodTypesAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 originalPromiseResult.StatusCode === "200" ?
    //                     ShowToast("Timesheet Period Type Update Successfully", 'Success', "success", "toast-top-right") :
    //                     ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
    //             }).catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     if (closeButtonRef.current) {
    //         closeButtonRef.current.click();
    //     }
    // }
    // const handleCloseOnClickEvent = () => {
    //     dispatch(resetSelectedRecordObjectInState());
    // }
    // const handleSystemTimesheetPeriodOptionChange = (data: any) => {
    //     const { value, label } = data;
    //     setSelectedSystemTimesheetPeriodTypeValue(systemTimesheetPeriodTypeArray.find((systemTimesheetPeriodType: any) => systemTimesheetPeriodType.value === value).value);
    // };
    // return (
    //     <>
    //         <Formik
    //             initialValues={{
    //                 ...currentFieldsData,
    //                 InitialDayOfTheMonth: currentFieldsData?.InitialDayOfTheMonth || 0,
    //                 TimesheetPeriodEffectiveDate: currentFieldsData?.TimesheetPeriodEffectiveDate || new Date(),
    //                 selectedSystemTimesheetPeriodTypeValue
    //             }}
    //             enableReinitialize={true}
    //             onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
    //             validationSchema={yup.object().shape({
    //                 TimesheetPeriodEffectiveDate: yup.date().when('selectedSystemTimesheetPeriodTypeValue', ([selectedSystemTimesheetPeriodTypeValue], schema) => {

    //                     if (selectedSystemTimesheetPeriodTypeValue == 3) {
    //                         return yup.date().required('Effective Date is required');
    //                     }
    //                     return schema;
    //                 }),
    //                 InitialDayOfTheMonth: yup.string().when('selectedSystemTimesheetPeriodTypeValue', ([selectedSystemTimesheetPeriodTypeValue], schema) => {

    //                     if (selectedSystemTimesheetPeriodTypeValue == 5) {
    //                         return yup.number().required('Initial Day Of The Month is required')
    //                             .min(1, 'Initial Day Of The Month value must be greater than or equal to 1')
    //                             .max(31, 'Initial Day Of The Month value must be less than or equal to 31');
    //                     }
    //                     return schema;
    //                 }),

    //             })}>
    //             {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
    //                 <Fragment>
    //                     <form>
    //                         <div className='card-body'>
    //                             {isLoading ?
    //                                 <div className="col-md-12">
    //                                     <span className='indicator-progress' style={{ display: 'block' }}>
    //                                         <span className='spinner-border spinner-border-md ms-2'></span>
    //                                     </span>
    //                                 </div>
    //                                 : <>
    //                                     <div className='row'>
    //                                         <div className="col-md-6 mb-2">
    //                                             <label className="form-label">Timesheet Period Type</label>
    //                                             <Select
    //                                                 value={(values.SystemTimesheetPeriodTypeId != "" && values.SystemTimesheetPeriodTypeId != null) ? systemTimesheetPeriodTypeArray.find((option: any) => option.value == values.SystemTimesheetPeriodTypeId) : 0}
    //                                                 className="basic-single"
    //                                                 classNamePrefix="select"
    //                                                 isSearchable={true}
    //                                                 id="SystemTimesheetPeriodTypeId"
    //                                                 name="SystemTimesheetPeriodTypeId"
    //                                                 onBlur={() => setFieldTouched('SystemTimesheetPeriodTypeId', true)}
    //                                                 onChange={(selectedOption) => {
    //                                                     handleChange({
    //                                                         target: {
    //                                                             id: "SystemTimesheetPeriodTypeId",
    //                                                             value: selectedOption?.value
    //                                                         },
    //                                                     });
    //                                                     handleSystemTimesheetPeriodOptionChange(selectedOption);
    //                                                 }}
    //                                                 options={systemTimesheetPeriodTypeArray}
    //                                                 styles={colourStyles}
    //                                                 isDisabled={true}
    //                                             />

    //                                         </div>
    //                                         {selectedSystemTimesheetPeriodTypeValue == 3 ?
    //                                             <div className="col-md-6 mb-2">
    //                                                 <label className="form-label">Effective Date</label>
    //                                                 <DatePicker
    //                                                     selected={values.TimesheetPeriodEffectiveDate != "" ? values.TimesheetPeriodEffectiveDate : new Date()}
    //                                                     id="TimesheetPeriodEffectiveDate"
    //                                                     name="TimesheetPeriodEffectiveDate"
    //                                                     className="form-control dataPicker w-100px ps-4 form-control-dark btn-icon-dark btn-text-dark"
    //                                                     onChange={(date) => setFieldValue('TimesheetPeriodEffectiveDate', date)}
    //                                                     onBlur={() => setFieldTouched('TimesheetPeriodEffectiveDate')}
    //                                                     dateFormat="dd/MM/yyyy"
    //                                                 >
    //                                                 </DatePicker>

    //                                                 <div>
    //                                                     {touched.TimesheetPeriodEffectiveDate && errors.TimesheetPeriodEffectiveDate &&
    //                                                         <p className='errorMsg'>{errors.TimesheetPeriodEffectiveDate as string}</p>
    //                                                     }
    //                                                 </div>
    //                                             </div>
    //                                             : (
    //                                                 null
    //                                             )}
    //                                         {selectedSystemTimesheetPeriodTypeValue == 4 ?
    //                                             <div className="col-md-6 mb-2">
    //                                                 <label className="form-label">Period</label>
    //                                                 <Select
    //                                                     value={(values.SystemInitialDaysOfThePeriodId != null && values.SystemInitialDaysOfThePeriodId != "") ? systemInitialDaysOfThePeriodArray.find((option: any) => option.value == values.SystemInitialDaysOfThePeriodId) : 0}
    //                                                     className="basic-single"
    //                                                     classNamePrefix="select"
    //                                                     isSearchable={true}
    //                                                     id="SystemInitialDaysOfThePeriodId"
    //                                                     name="SystemInitialDaysOfThePeriodId"
    //                                                     onBlur={() => setFieldTouched('SystemInitialDaysOfThePeriodId', true)}
    //                                                     onChange={(selectedOption) => {
    //                                                         handleChange({
    //                                                             target: {
    //                                                                 id: "SystemInitialDaysOfThePeriodId",
    //                                                                 value: selectedOption?.value
    //                                                             },
    //                                                         });

    //                                                     }}
    //                                                     options={systemInitialDaysOfThePeriodArray}
    //                                                 />
    //                                                 <div>
    //                                                     {touched.SystemInitialDaysOfThePeriodId && errors.SystemInitialDaysOfThePeriodId &&
    //                                                         <p className='errorMsg'>{errors.SystemInitialDaysOfThePeriodId as string}</p>
    //                                                     }
    //                                                 </div>
    //                                             </div>
    //                                             : (
    //                                                 null
    //                                             )}
    //                                         {selectedSystemTimesheetPeriodTypeValue == 5 ?
    //                                             <div className="col-md-6 mb-2">
    //                                                 <label className="form-label">Initial Day Of Month</label>
    //                                                 <input type="number"
    //                                                     className="form-control"
    //                                                     name="InitialDayOfTheMonth"
    //                                                     id='InitialDayOfTheMonth'
    //                                                     value={(values.InitialDayOfTheMonth !== null && values.InitialDayOfTheMonth != "") ? values.InitialDayOfTheMonth : 0}
    //                                                     onChange={handleChange('InitialDayOfTheMonth')}
    //                                                     onBlur={() => setFieldTouched('InitialDayOfTheMonth')}
    //                                                 />
    //                                                 <div>
    //                                                     {touched.InitialDayOfTheMonth && errors.InitialDayOfTheMonth &&
    //                                                         <p className='errorMsg'>{errors.InitialDayOfTheMonth as string}</p>
    //                                                     }
    //                                                 </div>
    //                                             </div>
    //                                             : (
    //                                                 null
    //                                             )}
    //                                     </div>
    //                                 </>
    //                             }
    //                         </div>
    //                         <div className='card-footer pt-4 '>
    //                             <div className='d-flex flex-stack float-end'>
    //                                 <div className='d-flex align-items-center me-2'>
    //                                     <button
    //                                         ref={closeButtonRef}
    //                                         type="button"
    //                                         className="btn btn-light btn-sm me-2"
    //                                         id="kt_OffCanvas"
    //                                         onClick={handleCloseOnClickEvent}
    //                                     >
    //                                         Close
    //                                     </button>

    //                                     <button
    //                                         type="button"
    //                                         className="btn btn-light-primary btn-sm"
    //                                         onClick={() => handleSubmit()} disabled={!isValid}
    //                                         data-kt-element='send'
    //                                     >
    //                                         Update Timesheet Period Type
    //                                     </button>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </form>
    //                 </Fragment>
    //             )}
    //         </Formik>
    //     </>
    // )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', minHeight: '38px', height: '38px', padding: '-1px' }),
}
